import {Config} from "./config-viewmodel"

export interface AuthenticationModelState {
    config: Config
    toggleAuthenticationWidgetVisible: boolean
}

export class WidgetState implements AuthenticationModelState {
    config: Config = {
        eventListener: '',
        endpoints: {
            SignUpExternal: '',
            SignInExternal: '',
            SignUpSignIn: '',
        },
        labels: {
            myStudyChoice: '',
            doYouAlreadyHaveAMyStudyChoiceAccount: '',
            clickOnLoginToLoginToMyStudyChoice: '',
            login: '',
            areYouAlreadyAVUStudentOrEmployee: '',
            loginToYourVUDashboardAndActivate: '',
            loginWithYourVUnetId: '',
            dontHaveAnAccountYet: '',
            withAMyStudyChoiceAccountYouCan: '',
            registerForStudyChoiceActivities: '',
            youCanEasilyRegisterForAnOpenDay: '',
            saveYourFavoriteProgrammes: '',
            haveYouFoundOneOrMoreInterestingProgrammes: '',
            manageYourPersonalInfo: '',
            withAMyStudyChoiceAccountYouCanManage: '',
            wouldYouLikeToCreateAnAccount: '',
            clickOnTheButtonBelow: '',
            createAMyStudyChoiceAccount: '',
        }
    }
    toggleAuthenticationWidgetVisible: boolean = false
}
